import React from 'react';

/**
 * Shown when a plan limit is hit (HTTP 402 from the backend).
 * Always a modal — never a toast — because this is an important message.
 */
export default function PlanLimitModal({ error, onClose }) {
  if (!error) return null;

  const isPlanLimit = error.planLimit === true;
  const resource    = error.resource
    ? error.resource.charAt(0).toUpperCase() + error.resource.slice(1)
    : 'Resource';
  const current     = error.current  ?? 0;
  const max         = error.max      ?? 0;
  const available   = error.available ?? 0;

  return (
    <div style={S.overlay}>
      <div style={S.modal}>
        {/* Icon */}
        <div style={S.iconWrap}>
          <span style={{ fontSize: '30px' }}>📦</span>
        </div>

        <h2 style={S.title}>
          {isPlanLimit ? `${resource} Limit Reached` : 'Plan Limit'}
        </h2>

        {isPlanLimit && (
          <div style={S.usageBar}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span style={{ fontSize: '13px', color: 'var(--color-text-secondary)' }}>
                Current usage
              </span>
              <span style={{ fontSize: '13px', fontWeight: 700, color: 'var(--color-danger)' }}>
                {current} / {max}
              </span>
            </div>
            <div style={{ height: '8px', background: 'var(--color-bg)', borderRadius: '999px', overflow: 'hidden' }}>
              <div style={{
                height: '100%',
                width: `${Math.min(100, (current / max) * 100)}%`,
                background: 'var(--color-danger)',
                borderRadius: '999px',
              }} />
            </div>
            <p style={{ fontSize: '12px', color: 'var(--color-text-muted)', marginTop: '6px' }}>
              {available === 0
                ? `All ${max} ${resource?.toLowerCase()} slots are used.`
                : `${available} slot${available !== 1 ? 's' : ''} remaining.`}
            </p>
          </div>
        )}

        <p style={S.message}>{error.message}</p>

        <div style={S.actions}>
          <button onClick={onClose} style={S.closeBtn}>Got it</button>
          <a
            href="mailto:connect@mahashunya.in"
            style={S.upgradeBtn}
          >
            Contact Support to Upgrade
          </a>
        </div>
      </div>
    </div>
  );
}

const S = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 300, padding: '16px',
  },
  modal: {
    background: '#fff', borderRadius: '20px', padding: '32px 28px',
    width: '100%', maxWidth: '420px', textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
  },
  iconWrap: {
    width: '64px', height: '64px', borderRadius: '16px',
    background: '#FFF5F5', display: 'flex', alignItems: 'center',
    justifyContent: 'center', margin: '0 auto 16px',
    border: '1px solid #FEB2B2',
  },
  title:      { fontSize: '20px', fontWeight: 700, color: 'var(--color-danger)', marginBottom: '16px' },
  usageBar:   { background: 'var(--color-bg)', borderRadius: 'var(--radius-md)', padding: '12px 14px', marginBottom: '16px', textAlign: 'left' },
  message:    { fontSize: '14px', color: 'var(--color-text-secondary)', lineHeight: 1.7, marginBottom: '24px' },
  actions:    { display: 'flex', flexDirection: 'column', gap: '8px' },
  upgradeBtn: {
    display: 'block', padding: '11px', borderRadius: 'var(--radius-md)',
    background: 'var(--color-primary)', color: '#fff',
    fontSize: '14px', fontWeight: 600, textDecoration: 'none',
    border: 'none', cursor: 'pointer',
  },
  closeBtn: {
    padding: '11px', borderRadius: 'var(--radius-md)',
    background: 'var(--color-bg)', color: 'var(--color-text-secondary)',
    fontSize: '14px', border: '1px solid var(--color-border)', cursor: 'pointer',
  },
};
